import React, { useState, useEffect } from 'react';
import { Chip } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { authService } from '../services/AuthService';

const UserBadge: React.FC = () => {
  const { t } = useTranslation();
  const [assumedUser, setAssumedUser] = useState(authService.getAssumedUser());

  useEffect(() => {
    setAssumedUser(authService.getAssumedUser());
  }, []);

  if (!assumedUser.id || !assumedUser.name) {
    return null;
  }

  const handleClear = () => {
    authService.clearAssumedUser();
    setAssumedUser({ id: null, name: null });
    // Force page reload to ensure all components are re-rendered with new state
    window.location.reload();
  };

  return (
    <Chip
      label={t('users.assumedUser', 'Viewing as: {{name}}', { name: assumedUser.name })}
      color="primary"
      variant="outlined"
      onDelete={handleClear}
      deleteIcon={<CloseIcon fontSize="small" />}
      sx={{ 
        height: 32,
        maxWidth: { xs: '120px', sm: 'none' },
        '& .MuiChip-label': {
          px: 1,
          fontSize: { xs: '0.7rem', sm: '0.75rem' },
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        },
        '& .MuiChip-deleteIcon': {
          fontSize: '1rem',
          margin: '0 4px 0 -6px',
          '&:hover': {
            color: 'inherit'
          }
        }
      }}
    />
  );
};

export default UserBadge;

